import React from 'react'
import Hero from './Hero'
import AllTeam from './AllTeam'
import Intro from './Intro'
import Faq from '../global/Faq'

const MyTeam = () => {
  const myTeamFaqs = [
    {
        id: 1,
        question: "Are you a company?",
        answer: "No, we're not a traditional company in the traditional sense. We're a close-knit team of university friends who have come together to collaborate on projects. While we operate more like a freelancing collective, we share a common goal of making a positive impact through our combined skills and dedication.",
    },
    {
        id: 2,
        question: "Do you have any industry experience?",
        answer: "Yes, we all have been working in the tech industry for the past 1.5 years. Presently, we are engaged in freelancing, utilizing our collective experience to deliver high-quality web solutions to clients.",
    },
    {
        id: 3,
        question: "How did your team come together?",
        answer: "We were friends from university who had the same goals. You know how they say, 'like-minded people attract each other.' With similar mindsets and ambitions, we naturally gravitated towards each other. Recognizing our shared passion for technology and web development, we decided to collaborate on projects together.",
    },
    {
        id: 4,
        question: "What makes your team unique?",
        answer: `Our team stands out because of our diverse skill set and collaborative approach. Each member brings something different to the table, whether it's design flair, technical expertise, or project management skills. We work together closely, using our strengths to help each other. This teamwork helps us create great solutions for our clients.`,
    },
    {
        id: 5,
        question: "Can you share some of the projects you've worked on in the tech industry?",
        answer: "Visit My Projects page, where you can explore the various projects we have worked on together.",
    },
    {
        id: 6,
        question: "How do you handle conflicts or disagreements within the team?",
        answer: "When we have disagreements, we talk openly and respectfully. We listen to each other's ideas and try to find solutions that work for everyone. Our goal is to maintain a positive and collaborative work environment where everyone feels valued and heard.",
    },
    {
      id: 7,
      question: "What services do you all offer in web?",
      answer: "As I mentioned earlier, each member of our team brings unique skills to the table, allowing us to offer a wide range of services. From custom web design to frontend development, backend API creation, database management, and SEO services, we can handle it all.",
  },
  {
      id: 8,
      question: "What is your approach to handling multiple freelance projects simultaneously?",
      answer: "We are a team of good developers. When I have a heavy workload, I rely on their help to meet deadlines and maintain the quality of the product.",
  },
    
];
  return (
    <>
    <Hero/>
    <Intro/>
    <AllTeam/>
    <Faq faqsData={myTeamFaqs}/>
    </>
  )
}

export default MyTeam